/**
 * @ Author: mzc
 * @ Create Time: 2024-07-03 19:51:46
 * @ Modified by: mzc
 * @ Modified time: 2024-07-12 19:42:45
 * @ Description: 全局部分数据
 */
import dayjs from "dayjs";

const initalState = {
	count: 0,
	loginAccountCheckList: []
};
const commonReducer = (state = initalState, action) => {
	switch (action.type) {
		case "COMMON_UPDATE_COMMON_COUNT":
			return { ...state, count: action.payload };
		case "COMMON_UPDATE_COMMON_LOGINACCOUNTCHECKLIST":
			return { ...state, loginAccountCheckList: [...action.payload] };
		default:
			return state;
	}
};

export default commonReducer;
